
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"cls-1",attrs:{"d":"M11.48 13.86L2 8.39V19a1 1 0 001 1h18a1 1 0 001-1V8.37l-9.52 5.49a1 1 0 01-1 0zM21 4H3a1 1 0 00-1 1v1.08l10 5.76 10-5.77V5a1 1 0 00-1-1z"}})])
          )
        }
      }
    